module.exports = __webpack_public_path__ + "static/media/md.e614af49.svg";